import { useTranslation } from 'react-i18next';
import { WITHDRAWAL_TRANSLATION } from '../constants/common';
import {
  createTypeOfRequestOptions,
  createHRNSampleStatusOptions,
  createPaperConsentOptions,
} from '../constants/options';

interface WithdrawalOptions {
  typeOfRequestOptions: ReturnType<typeof createTypeOfRequestOptions>;
  hrnSampleStatusOptions: ReturnType<typeof createHRNSampleStatusOptions>;
  paperConsentOptions: ReturnType<typeof createPaperConsentOptions>;
}

export const useWithdrawalOptions = (): WithdrawalOptions => {
  const { t } = useTranslation(WITHDRAWAL_TRANSLATION);

  const typeOfRequestOptions = createTypeOfRequestOptions(t);
  const hrnSampleStatusOptions = createHRNSampleStatusOptions(t);
  const paperConsentOptions = createPaperConsentOptions(t);

  return {
    typeOfRequestOptions,
    hrnSampleStatusOptions,
    paperConsentOptions,
  };
};
